import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import system from './modules/system'
import settings from './modules/settings'
import admin from './modules/admin'
import auth from './modules/auth'
import users from './modules/users'
import roles from './modules/roles'
import home from './modules/home'
import notifications from './modules/notifications'
import companies from './modules/companies'
import userLogs from './modules/user-logs'
import parameters from './modules/parameters'
import brands from './modules/brands'
import suppliers from './modules/suppliers'
import productGroups from './modules/productGroups'
import branches from './modules/branches'
import products from './modules/products'
import reps from './modules/reps'
import clerks from './modules/clerks'
import customers from './modules/customers'
import clockings from './modules/clockings'
import orders from './modules/orders'
import quotations from './modules/quotations'
import reporting from './modules/reporting'
import stakeholders from "./modules/stakeholders"
import engagements from "./modules/engagements"
import pallets from './modules/pallets'
import catalogue from './modules/catalogue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    ...system,
    ...home,
    ...admin,
    ...auth,
    ...settings,
    ...users,
    ...notifications,
    ...roles,
    ...companies,
    ...parameters,
    ...userLogs,
    ...brands,
    ...suppliers,
    ...productGroups,
    ...branches,
    ...products,
    ...reps,
    ...clerks,
    ...customers,
    ...clockings,
    ...orders,
    ...quotations,
    ...reporting,
    ...stakeholders,
    ...engagements,
    ...pallets,
    ...catalogue
  ]
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated'){
      throw err
    } else{
      //Close the menu by default if mobile when route changes
      if (window.screen.width < 992) {
        store.commit("menu/setMenuState", "close");
      }
    }
  });
}

/// ////////////////////
// Before Each Route //
/// ////////////////////
router.beforeEach(async (to, from, next) => {

  // load view layout
  store.commit('app/setLayout', to.meta.layout + '-layout')

  // check if vuex has auth else fetch from local (in case of page refresh)
  if (localStorage.getItem('token') != null && store.getters['user.token'] == null) {
    store.commit('user/setAuth')
  }

  // Auth Required Pages
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login'
      })
    } else {
      next()
    }

    // guest only pages
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'home'
      })
    }
    // pages for both guest and authorized users
  } else {
    next()
  }
})


///////// Catch duplicates and reload
// function patchRouterMethod (router, methodName)
// {
//     router['old' + methodName] = router[methodName]
//     router[methodName] = async function (location)
//     {
//         return router['old' + methodName](location).catch((error) =>
//         {
//             if (error.name === 'NavigationDuplicated')
//             {
//                return this.currentRoute
//             }
//             throw error
//         })
//     }
// }

// patchRouterMethod(router, 'push')
// patchRouterMethod(router, 'replace')

export default router
